// extracted by css-extract-rspack-plugin
export default {"iconWrapper":"TaskLeadingVisual-module__iconWrapper__L9plt"};